import { render, staticRenderFns } from "./CoursesTestCompletionNoticeDialog.vue?vue&type=template&id=191ffc7c&"
import script from "./CoursesTestCompletionNoticeDialog.vue?vue&type=script&lang=ts&"
export * from "./CoursesTestCompletionNoticeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VBtn,VContent})
